import { call, put, takeLatest, all, fork } from "redux-saga/effects"
import {
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_TOTAL_WATCHER,
  GET_STATUS_WATCHER,
  SAVE_CONFIG_BENCHMARK_WATCHER,
} from "./constants"

import {
  getMeasureColorRangeFailed,
  getMeasureColorRangeSuccess,
  getMeasureTotalFailed,
  getMeasureTotalSuccess,
  getMeasureGeneralFailed,
  getMeasureGeneralSuccess,
  getStatusSuccess,
  getStatusWatcher,
  saveConfigBenchmarkFailed,
  saveConfigBenchmarkSuccess,
  getStatusFailed,
} from "./actions"
import {
  KEY_CHECKBOX_EXCLUDE,
  KEY_ISOLATED_METRICS,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
} from "../../../utils/storage"
import {
  getDivisionsAvailableApi,
  getMeasureColorRangeApi,
  getMeasureConfigApi,
  getMeasureReportApi,
  getMeasureTotalReportApi,
  putMeasureConfigApi,
} from "../../../utils/routes/routes-report"

export function* getStatusSaga(action) {
  try {
    const dataStatus = action.payload

    const [
      { data: resultMeasure },
      { data: resultTotal, user_type: resultUserType },
      {
        data: resultConfig,
        is_sector_data_available: resultIsSectorDataAvailable,
        company_sectors: resultCompanySectors,
        company_sectors_global: resultCompanySectorsGlobal,
        company_sector: resultCompanySector
      },
    ] = yield all([
      call(getMeasureReportApi, dataStatus.params),
      call(getMeasureTotalReportApi, dataStatus.params),
      call(getMeasureConfigApi, dataStatus.params),
    ])

    let divisions = null
   console.log("resultMeasure", resultMeasure,resultTotal)
    if (resultTotal) {
      const dataParams = {
        excludeParam: dataStatus.params.isExclude
          ? "&exclude=true"
          : "&exclude=false",
        id_measure: dataStatus.params.id_measure,
        id_division: dataStatus.params.id_divisionParent
          ? dataStatus.params.id_divisionParent
          : dataStatus.params.divisionToUseAmbassador,
        id_segment: dataStatus.params.id_segment,
      }
      const data = yield call(
        getDivisionsAvailableApi,
        dataParams
      )

      divisions = data.data

      if (!resultMeasure.has_isolated_metrics) {
        setItem(KEY_CHECKBOX_EXCLUDE, false)
        setItem(KEY_ISOLATED_METRICS, false)
      }
      yield put(
        getStatusSuccess({
          measureGeneral: resultMeasure,
          measureTotal: resultTotal,
          measureConfig: resultConfig,
          userType: resultUserType,
          isSectorDataAvailable: resultIsSectorDataAvailable,
          divisionsAvailable: divisions,
          companySectors: resultCompanySectors,
          companySectorsGlobal:resultCompanySectorsGlobal,
          companySector: resultCompanySector,
          divisionsData: data
        })
      )
    }
  } catch (error) {
    console.log(error)
    getStatusFailed()
    if (error.response && error.response.status === 404) {
      dataStatus.history.push("/error")
    } else if (error.response && error.response.status === 401) {
      dataStatus.history.push("/login")
    } else {
      error.status === 400
    }
  }
}

export function* getMeasureColorRangeSaga(action) {
  try {
    const response = yield call(getMeasureColorRangeApi, action.payload)
    yield put(getMeasureColorRangeSuccess(response.data))
  } catch (e) {
    yield put(getMeasureColorRangeFailed())
  }
}

export function* getMeasureTotalSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: resultMeasure } = yield call(
      getMeasureReportApi,
      dataStatus.params
    )
    const { data: resultTotal } = yield call(
      getMeasureTotalReportApi,
      dataStatus.params
    )
    yield put(getMeasureTotalSuccess(resultTotal))
    yield put(getMeasureGeneralSuccess(resultMeasure))
  } catch (e) {
    yield put(getMeasureTotalFailed())
  }
}

export function* saveConfigBenchmarkSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: result } = yield call(putMeasureConfigApi, dataStatus)
    yield put(saveConfigBenchmarkSuccess(result))
    yield put(
      getStatusWatcher({
        isHome: true,
        id_measure: dataStatus.id_measure,
        history: dataStatus.history,
        isExclude:
          LOCAL_CHECKBOX_EXCLUDE() == "true" &&
          LOCAL_ISOLATED_METRICS() == "true",
        params: {
          id_measure: dataStatus.id_measure,
          id_division: null,
        },
      })
    )
  } catch (e) {
    yield put(saveConfigBenchmarkFailed())
  }
}

// Individual exports for testing
export default function* reportAdminSaga() {
  yield takeLatest(GET_STATUS_WATCHER, getStatusSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_MEASURE_TOTAL_WATCHER, getMeasureTotalSaga)
  yield takeLatest(SAVE_CONFIG_BENCHMARK_WATCHER, saveConfigBenchmarkSaga)
}
